// import axios from 'axios';
import axios from 'axios';
import store from '../redux/store';
import { logout, addToast } from '../redux/actions/authActions';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Now using the env variable
});

// Attach token if available
api.interceptors.request.use(
  (config) => {
    const { auth } = store.getState();
    console.log('Token found:', auth && auth.user && auth.user.token); // Debug log
    if (auth && auth.user && auth.user.token) {
      config.headers.Authorization = `Bearer ${auth.user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global error interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Here you could dispatch a generic error toast if desired
    if (error.response && error.response.status === 401) {
      // Dispatch a toast message to inform the user
      store.dispatch(addToast({
        id: Date.now(),
        message: 'Session expired. Please log in again.',
        variant: 'danger'
      }));
      // Dispatch logout action to clear auth state
      store.dispatch(logout());
      // Optionally, redirect to login page
      window.location.href = '/login/email';
    }
    return Promise.reject(error);
  }
);

export default api;
